
/**
 * 头部导航区域
 */

import HeaderNav from './HeaderNav.vue';

export default HeaderNav;